import React, {useEffect, useState} from 'react';
import {Button} from '@components';
import {Card, Form, Row, Col, ButtonGroup} from 'react-bootstrap';
import {Formik} from 'formik';
import * as yup from 'yup';
import {useLocation, useHistory} from 'react-router-dom';
import {toast} from 'react-toastify';
import InputFile from '@app/components/input-file/InputFile';
import {Get, Put} from '@app/utils/httpProvider';
import {useQuery, useQueryClient, useMutation} from 'react-query';
import Editor from '@app/components/editor/Editor';
import Select from 'react-select';
import {NIL as NIL_UUID} from 'uuid';
import {AsyncPaginate} from 'react-select-async-paginate';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import {
    messageError,
    messageToast,
    acceptImage,
    objectDataTypeCategory,
    styleSelectDefault,
    styleSelectError,
    status200,
    dataTypeCategory,
    objectDataTypeVideo,
    objectTypeQA,
    objectAnswerChoice,
    answerChoice,
    objectSentenceType,
    sentenceType,
    objectDeviceStatus,
    role,
    objectTrangThaiDeNghi,
    DATE_TIME_REACT_FORMAT,
    DATE_TIME_REACT_WITHOUT_HOUR_FORMAT,
    objectLoai,
    objectLoaiXuLy,
    loaiNoiDungValue,
    objectLoaiNoiDung
} from '../../utils/define';
import {
    BaseGatewayImage,
    EXERCISE_API,
    DISEASE_API
} from '../../utils/apiUrl.js';
import {
    getInfomationAccountFromToken,
    isValidUrl,
    stripHtmlAndDollarSigns
} from '../../utils/helper';
import DatePicker from 'react-datepicker';
import {WithContext as ReactTags} from 'react-tag-input';
import VideoInput from '@app/components/video-input/VideoInput';

const schema = yup.object().shape({
    name: yup.string().required('Trường dữ liệu không được để trống'),
    disease: yup.object().nullable().required(messageError.emptyMessage),
    imageThumbnail: yup.string().required('Trường dữ liệu không được để trống')
});

const ExerciseEdit = () => {
    const history = useHistory();
    const queryClient = useQueryClient();
    const location = useLocation();
    const paramUrl = new URLSearchParams(location.search.substring(1));
    const exerciseId = paramUrl.get('id');

    // const inforAccount = getInfomationAccountFromToken();
    // let accountRoleManageDevice = false;

    // if (inforAccount && inforAccount.role) {
    //     const userRole = inforAccount.role.split(', ');
    //     accountRoleManageDevice =
    //         userRole.includes(role.Admin) || userRole.includes(role.Editor);
    //     // accountRoleBooker =
    //     //     userRole.includes(role.Admin) || userRole.includes(role.Booker);
    // }

    // const inforAccount = getInfomationAccountFromToken();

    // const listDepartment = useQuery(['getAllDepartment', giamSatChinhSuaPhanMemId], () =>
    //     Get(DONVIDENGHI_API.GET_ALL, null, null)
    // );

    // const listAccount = useQuery(['getAllAccount'], () =>
    //     Get(ACCOUNT_API.GET_PAGING_ACCOUNT, null, {
    //         PageIndex: 1,
    //         PageSize: 5000
    //     })
    // );

    // const lstAccount =
    //     listAccount && listAccount.data && listAccount.data.data
    //         ? listAccount.data.data.map((x) => ({
    //               label: x.fullName,
    //               value: x.id
    //           }))
    //         : [];

    // const lstDepartment =
    //     listDepartment && listDepartment.data
    //         ? listDepartment.data.map((x) => ({
    //               label: x.Ten,
    //               value: x.ID
    //           }))
    //         : [];

    // const listDevices = useQuery(['getAllParentQA'], () =>
    //     Get(DEVICE_API.GET_PAGING, null, {
    //         PageIndex: 1,
    //         PageSize: 10000
    //     })
    // );

    // const lstDevice =
    //     listDevices && listDevices.data && listDevices.data.data
    //         ? listDevices.data.data.$values
    //               .filter((s) => s.id != deviceId)
    //               .map((x) => ({label: x.title, value: x.id}))
    //         : [];

    const exerciseItem = useQuery([exerciseId], () =>
        Get(EXERCISE_API.GET_ITEM, exerciseId)
    );

    // const listCate = useQuery(['getAllCate'], () =>
    //     Get(CATEGORY_API.GET_ALL_CATEGORY)
    // );

    const editFunc = useMutation((value) =>
        Put(EXERCISE_API.UPDATE_ITEM, exerciseId, value)
    );

    const handleEdit = async (values) => {
        const model = {...values};

        model.id = exerciseId;

        model.diseaseId =
            values.disease === '' ||
            values.disease === 'null' ||
            values.disease === undefined
                ? ''
                : values.disease.value;

        editFunc.mutate(model, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastUpdateError);
                } else {
                    toast.success(messageToast.messageToastUpdateSuccess);
                    // queryClient.setQueryData(diseaseId, model);
                    queryClient.invalidateQueries([exerciseId]);
                    history.goBack();
                }
            },
            onError: (res) => {
                toast.error(
                    res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
                );
            }
        });
    };

    // const loadOptions = async (inputValue, loadedOptions, {page}) => {
    //     const filteredOptions = lstDepartment
    //         .filter((option) =>
    //             option.label.toLowerCase().includes(inputValue.toLowerCase())
    //         )
    //         .slice(0, 6);

    //     // Return all filtered options, no matter how many there are
    //     return {
    //         options: filteredOptions,
    //         hasMore: false,
    //         additional: {
    //             page: page + 1
    //         }
    //     };
    // };

    // const isLoading = cateItem.isLoading || listCate.isLoading;
    // const isError = cateItem.isError || listCate.isError;
    // const error = cateItem.isError ? cateItem.error : listCate.error;

    const isLoading = exerciseItem.isLoading ? true : false;
    const isError = exerciseItem.isError ? true : false;
    const error = exerciseItem.isError ? exerciseItem.error : null;

    // let menuData = [
    //     {
    //         name: 'Danh mục gốc',
    //         id: 'null',
    //         parentId: NIL_UUID
    //     }
    // ];
    // if (!listCate.isLoading && !listCate.isError) {
    //     menuData = menuData
    //         .concat(listCate.data.data.$values)
    //         .filter((x) => x.id !== cateId);
    // }

    // const loadOptionsAccount = async (inputValue, loadedOptions, {page}) => {
    //     const filteredOptions = lstAccount
    //         .filter((option) =>
    //             option.label.toLowerCase().includes(inputValue.toLowerCase())
    //         )
    //         .slice(0, 6);

    //     // Return all filtered options, no matter how many there are
    //     return {
    //         options: filteredOptions,
    //         hasMore: false,
    //         additional: {
    //             page: page + 1
    //         }
    //     };
    // };

    const loadOptions = async (search, loadedOptions, {page}) => {
        const pageSize = 10;
        const res = await Get(DISEASE_API.GET_PAGING, null, {
            PageIndex: page,
            PageSize: pageSize,
            Keyword: search // pass the input text to filter server-side
        });

        const data = res.data || [];
        const options = data.map((x) => ({
            label: `${x.name}`,
            value: x.id
        }));

        // assume your API returns total count or a flag for more pages
        const hasMore = data.length === pageSize;
        return {
            options,
            hasMore,
            additional: {page: page + 1}
        };
    };

    return (
        <Card>
            <Card.Header as="h5">Xem hoặc sửa giám sát bệnh lý</Card.Header>
            <Card.Body>
                {isLoading ? (
                    <div>Đang tải...</div>
                ) : isError ? (
                    <div>Có lỗi xảy ra: ${error.message}</div>
                ) : exerciseItem.data == null ? (
                    <div>Danh mục không tồn tại</div>
                ) : (
                    <Formik
                        enableReinitialize
                        validationSchema={schema}
                        onSubmit={(values) => handleEdit(values)}
                        initialValues={{
                            name:
                                exerciseItem.data && exerciseItem.data.name
                                    ? exerciseItem.data.name
                                    : '',
                            description:
                                exerciseItem.data &&
                                exerciseItem.data.description
                                    ? exerciseItem.data.description
                                    : '',
                            // practiceCountMinimum:
                            //     exerciseItem.data &&
                            //     exerciseItem.data.practiceCountMinimum
                            //         ? exerciseItem.data.practiceCountMinimum
                            //         : '',
                            // practiceCountMaximum:
                            //     exerciseItem.data &&
                            //     exerciseItem.data.practiceCountMaximum
                            //         ? exerciseItem.data.practiceCountMaximum
                            //         : '',
                            imagePath:
                                exerciseItem.data && exerciseItem.data.imagePath
                                    ? exerciseItem.data.imagePath
                                    : '',
                            imageThumbnail:
                                exerciseItem.data &&
                                exerciseItem.data.imageThumbnail
                                    ? exerciseItem.data.imageThumbnail
                                    : '',
                            // diseaseId: exerciseItem.data && exerciseItem.data.diseaseId
                            //         ? exerciseItem.data.diseaseId
                            //         : '',
                            disease:
                                exerciseItem.data && exerciseItem.data.disease
                                    ? [exerciseItem.data.disease].map((x) => ({
                                          label: x.name,
                                          value: x.id
                                      }))[0]
                                    : null,
                            videoLink:
                                exerciseItem.data && exerciseItem.data.videoLink
                                    ? exerciseItem.data.videoLink
                                    : ''
                        }}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            values,
                            errors,
                            setFieldValue
                        }) => (
                            <Form noValidate onSubmit={handleSubmit}>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Tên *
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control
                                            placeholder="Tên"
                                            type="text"
                                            name="name"
                                            value={values.name}
                                            onChange={handleChange}
                                            isInvalid={!!errors.name}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.name}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Ảnh đại diện *
                                    </Form.Label>
                                    <Col sm="10">
                                        <InputFile
                                            enableReinitialize={true}
                                            values={
                                                values.imageThumbnail
                                                    ? [
                                                          isValidUrl(
                                                              values.imageThumbnail
                                                          )
                                                              ? values.imageThumbnail
                                                              : BaseGatewayImage +
                                                                values.imageThumbnail
                                                      ]
                                                    : []
                                            }
                                            name="imageThumbnail"
                                            accept={acceptImage}
                                            onChange={(files) => {
                                                if (files.length > 0) {
                                                    setFieldValue(
                                                        'imagePath',
                                                        files[0].filePath,
                                                        true
                                                    );
                                                    setFieldValue(
                                                        'imageThumbnail',
                                                        files[0].thumbPath,
                                                        true
                                                    );
                                                } else {
                                                    setFieldValue(
                                                        'imagePath',
                                                        '',
                                                        true
                                                    );
                                                    setFieldValue(
                                                        'imageThumbnail',
                                                        '',
                                                        true
                                                    );
                                                }
                                            }}
                                        />

                                        <div
                                            style={{
                                                display: 'block',
                                                color: '#dc3545'
                                            }}
                                            className="invalid-feedback"
                                        >
                                            {errors.imageThumbnail}
                                        </div>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Mô tả
                                    </Form.Label>
                                    <Col sm="10">
                                        <Editor
                                            name="description"
                                            value={values.description}
                                            onChange={async (value) => {
                                                setFieldValue(
                                                    'description',
                                                    value
                                                );

                                                if (
                                                    values.imagePath === '' ||
                                                    values.imageThumbnail === ''
                                                ) {
                                                    var divContent =
                                                        document.createElement(
                                                            'div'
                                                        );
                                                    divContent.innerHTML =
                                                        value;
                                                    var imgs =
                                                        divContent.querySelectorAll(
                                                            'img'
                                                        );
                                                    if (
                                                        imgs &&
                                                        imgs.length > 0
                                                    ) {
                                                        for (
                                                            let i = 0;
                                                            i < imgs.length;
                                                            i++
                                                        ) {
                                                            if (
                                                                imgs[
                                                                    i
                                                                ].getAttribute(
                                                                    'src'
                                                                )
                                                            ) {
                                                                console.log(
                                                                    'element.getAttribute',
                                                                    imgs[
                                                                        i
                                                                    ].getAttribute(
                                                                        'src'
                                                                    )
                                                                );
                                                                await setFieldValue(
                                                                    'imagePath',
                                                                    imgs[
                                                                        i
                                                                    ].getAttribute(
                                                                        'src'
                                                                    ),
                                                                    true
                                                                );
                                                                await setFieldValue(
                                                                    'imageThumbnail',
                                                                    imgs[
                                                                        i
                                                                    ].getAttribute(
                                                                        'src'
                                                                    ),
                                                                    true
                                                                );
                                                                break;
                                                            }
                                                        }
                                                    }
                                                }
                                            }}
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Chọn bệnh lý *
                                    </Form.Label>
                                    <Col sm="10">
                                        <AsyncPaginate
                                            name="disease"
                                            id="disease"
                                            placeholder="Chọn bệnh lý"
                                            value={values.disease}
                                            loadOptions={loadOptions}
                                            styles={styleSelectDefault}
                                            isClearable
                                            onChange={(selectedOption) => {
                                                // const event = {
                                                //     target: {
                                                //         name: 'accountPatients',
                                                //         value: selectedOption
                                                //     }
                                                // };
                                                // setAccountHisId(event);
                                                setFieldValue(
                                                    'disease',
                                                    selectedOption,
                                                    true
                                                );
                                            }}
                                            additional={{
                                                page: 1
                                            }}
                                        />
                                        <div
                                            style={{
                                                display: 'block',
                                                color: '#dc3545'
                                            }}
                                            className="invalid-feedback"
                                        >
                                            {errors.disease}
                                        </div>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Đường dẫn video
                                    </Form.Label>
                                    <Col sm="10">
                                        <VideoInput
                                            isInvalid={!!errors.videoLink}
                                            errorsValue={errors.videoLink}
                                            value={values.videoLink}
                                            onChangeProp={(value) => {
                                                setFieldValue(
                                                    'videoLink',
                                                    value
                                                );
                                            }}
                                        />
                                    </Col>
                                </Form.Group>
                                {/* <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Số lần tối thiểu tập mỗi buổi
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control
                                            placeholder="Số lần tối thiểu tập mỗi buổi"
                                            type="number"
                                            name="practiceCountMinimum"
                                            value={values.practiceCountMinimum}
                                            onChange={handleChange}
                                            // isInvalid={!!errors.practiceCountMinimum}
                                        />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label className="col-sm-2 col-form-label">
                                        Số lần tối đa tập mỗi buổi
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control
                                            placeholder="Số lần tối đa tập mỗi buổi"
                                            type="number"
                                            name="practiceCountMaximum"
                                            value={values.practiceCountMaximum}
                                            onChange={handleChange}
                                        />
                                    </Col>
                                </Form.Group> */}
                                <Form.Group as={Row} className="mb-3">
                                    <Col md={{span: 10, offset: 2}}>
                                        <ButtonGroup className="mb-2">
                                            <Button
                                                type="submit"
                                                theme="primary"
                                            >
                                                Sửa
                                            </Button>
                                            &nbsp;&nbsp;&nbsp;
                                            <Button
                                                onClick={() => history.goBack()}
                                                theme="secondary"
                                            >
                                                Hủy
                                            </Button>
                                        </ButtonGroup>
                                    </Col>
                                </Form.Group>
                            </Form>
                        )}
                    </Formik>
                )}
            </Card.Body>
        </Card>
    );
};

export default ExerciseEdit;
